import React, { useState } from 'react'

import styles from './index.module.scss'
import AwardLabelPc from '../../public/award_label_for_pc.png'
import AwardLabelSp from '../../public/award_label_for_sp.png'
import CourseValuePc from '../../public/course_value_pc.png'
import CampaignValuePc from '../../public/campaign_value_pc.png'
import CampaignValueDetailPc from '../../public/campaign_value_detail_pc.png'
import SubsidyValuePc from '../../public/subsidy_value_pc.png'
import SubsidyValueDetailPc from '../../public/subsidy_value_detail_pc.png'
import SubsidyValuePriceDetailPc from '../../public/subsidy_value_price_detail_pc.png'
import CourseValueSp from '../../public/course_value_sp.png'
import CampaignValueSp from '../../public/campaign_value_sp.png'
import CampaignValueDetailSp from '../../public/campaign_value_detail_sp.png'
import SubsidyValueSp from '../../public/subsidy_value_sp.png'
import SubsidyValueDetailSp from '../../public/subsidy_value_detail_sp.png'
import SubsidyValuePriceDetailSp from '../../public/subsidy_value_price_detail_sp.png'
import ValueLabel from '../../public/value_label.png'
import ReservationMoveButton from '../ReservationMoveButton'

type Props = {
  isPc?: boolean
}

export const AwardContentForAB = ({ isPc }: Props) => {
  const [showCampaignDetail, setShowCampaignDetail] = useState(false)
  const [showSubsidyDetail, setShowSubsidyDetail] = useState(false)
  const [showSubsidyPriceDetail, setShowSubsidyPriceDetail] = useState(false)

  const getCampaignImage = () => {
    if (showCampaignDetail) {
      return isPc ? CampaignValueDetailPc : CampaignValueDetailSp
    }
    return isPc ? CampaignValuePc : CampaignValueSp
  }

  const getSubsidyImage = () => {
    if (showSubsidyDetail && showSubsidyPriceDetail) {
      return isPc ? SubsidyValuePriceDetailPc : SubsidyValuePriceDetailSp
    }
    if (showSubsidyDetail) {
      return isPc ? SubsidyValueDetailPc : SubsidyValueDetailSp
    }
    return isPc ? SubsidyValuePc : SubsidyValueSp
  }

  const handleCampaignClick = () => {
    setShowCampaignDetail(!showCampaignDetail)
  }

  const handleSubsidyClick = () => {
    setShowSubsidyDetail(!showSubsidyDetail)
  }

  const handleSubsidyPriceClick = () => {
    setShowSubsidyPriceDetail(!showSubsidyPriceDetail)
  }

  return (
    <>
      <section id="award-content" className={styles.container}>
        <div className={styles.awardLabelSection}>
          <img
            src={isPc ? AwardLabelPc.src : AwardLabelSp.src}
            className={styles.awardLabel}
          />
        </div>

        <div className={styles.awardContentSection}>
          {isPc ? (
            <div className={styles.pcContentContainer}>
              <img src={ValueLabel.src} className={styles.valueLabel} />
              <img src={CourseValuePc.src} className={styles.courseValue} />
              <div className={styles.horizontalContainer}>
                <div className={styles.campaignContainer}>
                  <div
                    className={`${styles.showDetailToggle} ${
                      styles.campaignToggle
                    } ${
                      showCampaignDetail
                        ? styles.campaignDetailOpen
                        : styles.campaignDetailClose
                    }`}
                    onClick={handleCampaignClick}
                  />
                  <img
                    src={getCampaignImage().src}
                    className={styles.campaignValue}
                  />
                </div>
                <div className={styles.subsidyContainer}>
                  <div
                    className={`${styles.showDetailToggle} ${
                      styles.subsidyToggle
                    } ${
                      showSubsidyDetail
                        ? styles.subsidyDetailOpen
                        : styles.subsidyDetailClose
                    }`}
                    onClick={handleSubsidyClick}
                  />
                  {showSubsidyDetail && (
                    <>
                      <div
                        className={`${styles.showPriceDetailToggle} ${
                          showSubsidyPriceDetail
                            ? styles.subsidyPriceDetailOpen
                            : styles.subsidyPriceDetailClose
                        }`}
                        onClick={handleSubsidyPriceClick}
                      />
                      <a
                        className={styles.linkToPricePageButton}
                        href="https://shelikes.jp/landing_pages/price"
                        target="_blank"
                        rel="noreferrer"
                      />
                    </>
                  )}
                  <img
                    src={getSubsidyImage().src}
                    className={styles.subsidyValue}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.spContentContainer}>
              <img src={ValueLabel.src} className={styles.valueLabel} />
              <img src={CourseValueSp.src} className={styles.courseValue} />
              <div className={styles.campaignContainer}>
                <div
                  className={`${styles.showDetailToggle} ${
                    styles.campaignToggle
                  } ${
                    showCampaignDetail
                      ? styles.campaignDetailOpen
                      : styles.campaignDetailClose
                  }`}
                  onClick={handleCampaignClick}
                />
                <img
                  src={getCampaignImage().src}
                  className={styles.campaignValue}
                />
              </div>
              <div className={styles.subsidyContainer}>
                <div
                  className={`${styles.showDetailToggle} ${
                    styles.subsidyToggle
                  } ${
                    showSubsidyDetail
                      ? styles.subsidyDetailOpen
                      : styles.subsidyDetailClose
                  }`}
                  onClick={handleSubsidyClick}
                />
                {showSubsidyDetail && (
                  <>
                    <div
                      className={`${styles.showPriceDetailToggle} ${
                        showSubsidyPriceDetail
                          ? styles.subsidyPriceDetailOpen
                          : styles.subsidyPriceDetailClose
                      }`}
                      onClick={handleSubsidyPriceClick}
                    />
                    <a
                      className={styles.linkToPricePageButton}
                      href="https://shelikes.jp/landing_pages/price"
                      target="_blank"
                      rel="noreferrer"
                    />
                  </>
                )}
                <img
                  src={getSubsidyImage().src}
                  className={styles.subsidyValue}
                />
              </div>
            </div>
          )}
          <ReservationMoveButton
            moveToId="reservation-step-summary"
            isAB={true}
          />
        </div>
      </section>
    </>
  )
}
